var _rect, _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoImageDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.875,
    width: 30.25,
    height: 30.25,
    rx: 1.77941,
    fill: "#6D7D8B",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03516 15.2122C8.03516 12.2414 8.03516 10.756 8.95808 9.83308C9.88099 8.91016 11.3664 8.91016 14.3372 8.91016H15.9128C18.8836 8.91016 20.369 8.91016 21.2919 9.83308C22.2148 10.756 22.2148 12.2414 22.2148 15.2122V16.7878C22.2148 19.7586 22.2148 21.244 21.2919 22.1669C20.369 23.0898 18.8836 23.0898 15.9128 23.0898H14.3372C11.3664 23.0898 9.88099 23.0898 8.95808 22.1669C8.03516 21.244 8.03516 19.7586 8.03516 16.7878V15.2122Z",
    stroke: "#6D7D8B",
    strokeWidth: 1.57552
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6378 17.2477L20.623 17.2329C20.3161 16.926 20.0513 16.6612 19.815 16.462C19.5653 16.2516 19.2935 16.0666 18.9586 15.9655C18.5134 15.8312 18.0385 15.8312 17.5934 15.9655C17.2584 16.0666 16.9866 16.2516 16.737 16.462C16.5006 16.6612 16.2358 16.926 15.9289 17.233L15.9065 17.2554C15.6647 17.4971 15.5225 17.6382 15.4121 17.7295L15.3962 17.7424L15.3862 17.7245C15.3177 17.5988 15.238 17.4149 15.1033 17.1007L15.0612 17.0026L15.0438 16.9619C14.7634 16.3076 14.528 15.7582 14.2949 15.3441C14.0548 14.9175 13.7557 14.5174 13.2893 14.2836C12.9003 14.0886 12.4651 14.0047 12.0315 14.0413C11.5117 14.0852 11.0853 14.3456 10.7039 14.6525C10.3843 14.9098 10.0255 15.2601 9.60938 15.6751V16.7877C9.60938 17.1953 9.60961 17.5645 9.61181 17.9006L10.4905 17.0219C11.0334 16.479 11.396 16.118 11.6918 15.8799C11.9839 15.6447 12.1096 15.6159 12.164 15.6113C12.3085 15.5991 12.4536 15.627 12.5832 15.692C12.632 15.7164 12.738 15.7899 12.9219 16.1168C13.1081 16.4477 13.3107 16.9175 13.6131 17.6232L13.6552 17.7214L13.668 17.7514C13.7853 18.0252 13.8943 18.2795 14.0031 18.4789C14.1171 18.6879 14.2826 18.9383 14.5614 19.1109C14.8902 19.3143 15.2822 19.3898 15.663 19.323C15.986 19.2663 16.2327 19.0954 16.4161 18.9436C16.5912 18.7989 16.7868 18.6032 16.9974 18.3926L16.9974 18.3926L17.0205 18.3695C17.3563 18.0337 17.5735 17.8174 17.7523 17.6667C17.9235 17.5224 18.0044 17.4872 18.0484 17.4739C18.1968 17.4291 18.3551 17.4291 18.5035 17.4739C18.5476 17.4872 18.6284 17.5224 18.7996 17.6667C18.9784 17.8174 19.1957 18.0337 19.5314 18.3695L20.5941 19.4321C20.6303 18.8666 20.6367 18.1635 20.6378 17.2477Z",
    fill: "#6D7D8B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.6699,
    cy: 12.4551,
    r: 1.18164,
    fill: "#6D7D8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImageDefault);
export default __webpack_public_path__ + "static/media/noImageDefault.f55ca166.svg";
export { ForwardRef as ReactComponent };